import React, { useState, useEffect } from 'react';
import { ProgressBarDownload } from "./progressbardownload";
import { PdfToPngConverter } from "./pdfconverter";
import {CDAWEBORIGINURL} from './../../constants.js';


/**
 * Modal tabs that deals with organising, interacting and displaying  plots for a given dataset.
 *
 * @param props.defaultTab Number the default index that will be used to select tab to display.
 * @param props.tabsData Array of data that will be displayed in each tab.
 * @param props.deleteData Function that remove data from tabsData.
 * @param props.setCurrentTab Function that is called when a new tab is selected.
 * @return JSX
 */
export function CdaWebModalTabs(props) {
    const { defaultTab, tabsData, deleteData, updatePNGImageUrl, setCurrentTab, enhanceImageArr } = props;
    const [activeTab, setActiveTab] = useState(defaultTab);
    const imageEnhanced = tabsData[defaultTab]?.png.startsWith(CDAWEBORIGINURL) ? false : true;
    const [imageUrl, setImageUrl] = useState(imageEnhanced ? tabsData[defaultTab]?.png : "");
    const [cdaImageStatus, setCDAImageStatus] = useState(enhanceImageArr[defaultTab]
                                                         ? (imageEnhanced ? "success" : "neutral")
                                                         : "none");
    useEffect(() => {
         setActiveTab(defaultTab);
         console.log(`The array for enhance is ${JSON.stringify(enhanceImageArr)} ${typeof enhanceImageArr}`);
         const imageEnhanced = tabsData[defaultTab]?.png.startsWith("https://cdaweb.gsfc.nasa.gov") ? false : true;
         const imgSts = enhanceImageArr[defaultTab] ? (imageEnhanced ? "success" : "neutral") : "none";
         setCDAImageStatus(imgSts);
     }, [defaultTab, tabsData, enhanceImageArr]);

    const handleTabClick = (index) => {
        setCurrentTab(index);
    };

    const handleClose = (index) => {
        setActiveTab(0);
        setCurrentTab(0);
        deleteData(index);
    };

    const handleImageStatusChange = (status) => {
        setCDAImageStatus(status);
    };


     return (
       <div className="cdaWebModalTabsContainer">
         <div className="cdaWebModalTabs" >
           {tabsData.map((tab, index) => (
             <div key={index} onClick={() => handleTabClick(index)} className={`cdaWebModalTab ${index === activeTab ? 'active' : ''} cdaWebModalTabTitle`}>
               <div
                 key={index+100}
                 >
                 Plot {index + 1}
               </div>
               <div>
                 <button className="closeButton" onClick={()=>handleClose(index)}>X</button>
               </div>
             </div>
           ))}
         </div>
         <div>
           {
             tabsData[activeTab]?.png
             &&
             <>
               { cdaImageStatus === "neutral" &&
                 <div className="cdaWebImageStatusWrapper">
                   <div className="cdaWebImageStatusContainer cdaWebImageStatusWrapperRow">
                     <h3 className= "cdaWebModalTabLoadingMessage">
                       <div className="cdaWebModalTextSpinner"></div>
                       Enhancing image
                     </h3>
                     <div className="cdaWebImageStatusProgressBarWrapper"><ProgressBarDownload url={tabsData[activeTab]?.pdf} knownSizeBytes = {null} setUrl = {setImageUrl} setImageState = {handleImageStatusChange}/></div>
                   </div>
                 </div>
               }
               { cdaImageStatus === "loaded" &&
                 <div className="cdaWebImageStatusWrapper">
                   <div className="cdaWebImageStatusContainer cdaWebImageStatusWrapperRow">
                     <h3 className= "cdaWebModalTabLoadingMessage">
                       <div className="cdaWebModalTextSpinner"></div>
                       Enhancing image
                     </h3>
                     <div><PdfToPngConverter pdfUrl={imageUrl} status={cdaImageStatus} onStatusChange={handleImageStatusChange} setImageUrl = {setImageUrl} tabIndex={defaultTab} updatePNGImageUrl= {updatePNGImageUrl} externalLink={false} /></div>
                   </div>
                 </div>
               }
               { cdaImageStatus === "enhancing" &&
                 <div className="cdaWebImageStatusWrapper">
                   <div className="cdaWebImageStatusContainer cdaWebImageStatusWrapperRow">
                     <h3 className= "cdaWebModalTabLoadingMessage">
                       <div className="cdaWebModalTextSpinner"></div>
                       Displaying
                     </h3>
                   </div>
                 </div>
               }
               { cdaImageStatus === "success" &&
                 <div className="cdaWebImageStatusWrapper">
                   <div className="cdaWebImageStatusContainer cdaWebImageStatusWrapperRow">
                     <h3 className= "cdaWebModalTabSuccessMessage">
                       <div className="cdaWebModalSuccessSpinner"></div>
                       Image enhanced
                     </h3>
                  </div>
                 </div>
               }
               { cdaImageStatus === "error" &&
                 <div className="cdaWebImageStatusWrapper">
                   <div className="cdaWebImageStatusContainer cdaWebImageStatusWrapperRow">
                     <h3 className= "cdaWebModalTabSuccessMessage">
                       <div className="cdaWebModalSuccessSpinner"></div>
                       Unable to enhance image
                     </h3>
                   </div>
                 </div>
               }
               { cdaImageStatus === "none" &&
                 <div className="cdaWebImageStatusWrapper">
                   <div className="cdaWebImageStatusContainer cdaWebImageStatusWrapperRow">
                     <h3 className= "cdaWebModalTabSuccessMessage">
                       Plot ready
                     </h3>
                  </div>
                 </div>
               }
             </>
           }
         </div>
         <div className="cdaWebModalTabContainer">
           <div className="cdaWebModalTabContent">
             <div className="cdaWebPlotImage">
               {
                 tabsData[activeTab]?.png
                 &&
                 <>
                   {cdaImageStatus === "success" && <img alt="Plot" src={tabsData[activeTab]?.png} />}
                   {cdaImageStatus !== "success" && <img alt="Plot" src={tabsData[activeTab]?.png} className="cdaWebPlotImagePlaceholder" />}
                 </>
               }

             </div>
           </div>
         </div>
       </div>
     );
};
